<script lang="ts">
  export let error: boolean = false;
</script>

{#if error}
  <svg
    class="form-icon"
    data-testid="fail-mail-icon"
    width="1em"
    height="1em"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3125 0.8125H0.6875C0.376367 0.8125 0.125 1.06387 0.125 1.375V12.625C0.125 12.9361 0.376367 13.1875 0.6875 13.1875H15.3125C15.6236 13.1875 15.875 12.9361 15.875 12.625V1.375C15.875 1.06387 15.6236 0.8125 15.3125 0.8125ZM14.6094 2.76016V11.9219H1.39062V2.76016L0.905469 2.38223L1.59629 1.49453L2.34863 2.07988H13.6531L14.4055 1.49453L15.0963 2.38223L14.6094 2.76016ZM13.6531 2.07812L8 6.47266L2.34687 2.07812L1.59453 1.49277L0.903711 2.38047L1.38887 2.7584L7.39355 7.42715C7.56624 7.56131 7.77869 7.63413 7.99736 7.63413C8.21604 7.63413 8.42849 7.56131 8.60117 7.42715L14.6094 2.76016L15.0945 2.38223L14.4037 1.49453L13.6531 2.07812Z"
      fill="#DE5A54"
    />
  </svg>
{:else}
  <svg
    class="form-icon"
    data-testid="mail-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 1024 1024"
  >
    <path
      fill="currentColor"
      d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5l39.3-50.5l42.8 33.3h643.1l42.8-33.3l39.3 50.5l-27.7 21.5zM833.6 232L512 482L190.4 232l-42.8-33.3l-39.3 50.5l27.6 21.5l341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5l-39.3-50.5l-42.7 33.2z"
    />
  </svg>
{/if}

<style>
  .form-icon {
    position: absolute;
    top: 50%;
    margin-left: 0.5rem;
    transform: translateY(-50%);
  }
</style>
